$(document).ready(function() {
$('.video-sec__item').each(function() {
    var $section = $(this); // The current section
    var video = $section.find('video').get(0); // The video in this section
    var playButton = $section.find('.product-banner__btn a'); // The play/pause button in this section
    var image = $section.find('.video-sec__img'); // The image in this section
    var videoWrapper = $section.find('.video-sec__video'); // The video container in this section

    // Click event for the video play/stop button
    playButton.click(function() {
        if (video.paused) {
            // Show the video, hide the image, and play the video
            videoWrapper.show(); // Show the video container
            video.play(); // Play the video
            playButton.addClass('playing'); // Add class when playing
            playButton.find('.play-icon').hide(); // Hide play icon
            playButton.find('.pause-icon').show(); // Show pause icon
            image.hide(); // Hide the image when video is playing
        } else {
            // Pause the video and show the image again
            video.pause(); // Pause the video
            playButton.removeClass('playing'); // Remove class when paused
            playButton.find('.play-icon').show(); // Show play icon
            playButton.find('.pause-icon').hide(); // Hide pause icon
            image.show(); // Show the image again when the video is paused
        }
    });
});


});



$(document).ready(function() {
    $('.home-featured-collection slider-component ul li .card__content .card__information h3').matchHeight({ 
       byRow: 0,
    });
    $('.custom-collection-lists ul#product-grid li .card__content .card__information h3').matchHeight({ 
       byRow: 0,
    });
  
    var showChar = 481;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Read More";
    var lesstext = "Read Less";
    

    $('.more').each(function() {
        var content = $(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span><a href="" class="morelink">' + moretext + '</a></span>';
 
            $(this).html(html);
        }
 
    });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
  $('.collection-image__wrapper').slick({
        infinite: false,     
        slidesToShow: 3,     
        slidesToScroll: 1,   
        autoplay: false,
        dots: false,          
        arrows: true,
        prevArrow: '<button class="slick-prev slick-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,     
        slidesToScroll: 1, 
        },
      },
                {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,     
        slidesToScroll: 1, 
        },
      },
    ],
    });
    $(".accordion__title").on("click", function() {
		// e.preventDefault();
		var $this = $(this);
		if (!$this.hasClass("accordion-active")) {
			$(".accordion__content").slideUp();
            $(".accordion__item").removeClass("accoridan-wrapper__active");
			$(".accordion__title").removeClass("accordion-active");
			$('.accordion__arrow').removeClass('accordion__rotate');
		}
		$this.toggleClass("accordion-active");
        $(this).parent().toggleClass("accoridan-wrapper__active");
		$this.next().slideToggle();
		$('.accordion__arrow',this).toggleClass('accordion__rotate');
	});
    $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    dots: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.46967 5.47028C0.176777 5.76317 0.176777 6.23805 0.46967 6.53094L5.24264 11.3039C5.53553 11.5968 6.01041 11.5968 6.3033 11.3039C6.59619 11.011 6.59619 10.5361 6.3033 10.2433L2.06066 6.00061L6.3033 1.75797C6.59619 1.46508 6.59619 0.990203 6.3033 0.697309C6.01041 0.404416 5.53553 0.404416 5.24264 0.697309L0.46967 5.47028ZM1 6.75061L16 6.75061V5.25061L1 5.25061L1 6.75061Z" fill="black"/></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5303 6.53094C15.8232 6.23805 15.8232 5.76317 15.5303 5.47028L10.7574 0.69731C10.4645 0.404416 9.98959 0.404417 9.6967 0.69731C9.40381 0.990203 9.40381 1.46508 9.6967 1.75797L13.9393 6.00061L9.6967 10.2433C9.40381 10.5361 9.40381 11.011 9.6967 11.3039C9.98959 11.5968 10.4645 11.5968 10.7574 11.3039L15.5303 6.53094ZM15 5.25061L-6.55671e-08 5.25061L6.55671e-08 6.75061L15 6.75061L15 5.25061Z" fill="#000"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  });
});